import { comboCurries } from "../data/menu";

// "Choose Your Curry" block — used on Home and the Combo Meals page.
export const ChooseYourCurry = () => (
  <div className="bg-[#141414] border border-white/10 rounded-2xl p-7 md:p-9" data-testid="choose-your-curry">
    <h3 className="font-display text-xl md:text-2xl font-semibold text-[#ffd100] mb-2">Choose Your Curry</h3>
    <p className="text-neutral-400 text-base mb-6">Every combo above lets you pick your curry from the options below.</p>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div>
        <p className="flex items-center gap-2 text-white font-semibold text-lg mb-3">
          <span className="w-4 h-4 grid place-items-center border-2 border-emerald-500 rounded-[4px]"><span className="w-2 h-2 rounded-full bg-emerald-500" /></span>
          Vegetarian
        </p>
        <ul className="grid grid-cols-2 gap-x-4 gap-y-2 text-neutral-300 text-base">
          {comboCurries.veg.map((x) => <li key={x}>{x}</li>)}
        </ul>
      </div>
      <div>
        <p className="flex items-center gap-2 text-white font-semibold text-lg mb-3">
          <span className="w-4 h-4 grid place-items-center border-2 border-red-500 rounded-[4px]"><span className="w-2 h-2 rounded-full bg-red-500" /></span>
          Non-Vegetarian
        </p>
        <ul className="grid grid-cols-2 gap-x-4 gap-y-2 text-neutral-300 text-base">
          {comboCurries.nonVeg.map((x) => <li key={x}>{x}</li>)}
        </ul>
      </div>
    </div>
  </div>
);
